import { memo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import cn from 'bem-cn';

import { Popover } from '../Popover';
import { Icon } from '../Icon';
import { TabsProps } from './Tabs.types';

import './Tabs.scss';

const b = cn('tabs');

export const Tabs = memo<TabsProps>(({ items }) => {
    const location = useLocation();

    return (
        <div className={b()}>
            {items.map((item, index) => {
                const isActive = location.pathname === item.to;

                const renderTab = () => {
                    return (
                        <Link
                            key={index}
                            to={item.to}
                            className={b('item', { active: isActive, disabled: item.disabled })}
                        >
                            <Icon className={b('icon')} name={item.icon} size={20} />
                            <span className={b('text')}>{item.text}</span>
                        </Link>
                    );
                };

                if (item.popoverText) {
                    return (
                        <Popover key={index} content={item.popoverText} position="bottom" showOnHover autoClose={false}>
                            {renderTab()}
                        </Popover>
                    );
                }

                return renderTab();
            })}
        </div>
    );
});

Tabs.displayName = 'Tabs';
